import { SearchItemType } from '@/types/api'

import { getServiceUrl } from '@/app/_utils/select-api-service'

interface SendCardDataClickEventParams {
    queryId: string
    userToken: string
    id: string | null
    position: number | null
    type: SearchItemType | null
}

export function sendCardDataClickEvent({ userToken, id, queryId, type, position }: SendCardDataClickEventParams) {
    const baseUrl = getServiceUrl('ntl')

    const data = {
        userToken,
        docId: id,
        queryId,
        type: type,
        position,
    }
    const blob = new Blob([JSON.stringify(data)], { type: 'application/json' })

    if ('sendBeacon' in navigator) {
        navigator.sendBeacon(`${baseUrl}/stats/catalog/click`, blob)
    }
}
